import { render, staticRenderFns } from "./SubjectManage.vue?vue&type=template&id=443eac80&scoped=true"
import script from "./SubjectManage.vue?vue&type=script&lang=js"
export * from "./SubjectManage.vue?vue&type=script&lang=js"
import style0 from "./SubjectManage.vue?vue&type=style&index=0&id=443eac80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443eac80",
  null
  
)

export default component.exports